import { create } from "zustand";

interface ThemeState {
    theme: "light" | "dark";
    setTheme: (theme: "light" | "dark") => void;
    toggleTheme: () => void;
}

const initialTheme: "light" | "dark" = typeof window !== "undefined"
    ? (localStorage.getItem("theme") as "light" | "dark") ||
        (window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light")
    : "light";

// Apply the persisted theme class on load — toggles only cover later changes.
if (typeof window !== "undefined") {
    window.document.documentElement.classList.toggle(
        "dark",
        initialTheme === "dark",
    );
}

export const useThemeStore = create<ThemeState>((set) => ({
    theme: initialTheme,

    setTheme: (theme) => {
        set({ theme });
        if (typeof window !== "undefined") {
            const root = window.document.documentElement;
            if (theme === "dark") {
                root.classList.add("dark");
            } else {
                root.classList.remove("dark");
            }
            localStorage.setItem("theme", theme);
        }
    },

    toggleTheme: () => {
        set((state) => {
            const newTheme = state.theme === "light" ? "dark" : "light";
            if (typeof window !== "undefined") {
                const root = window.document.documentElement;
                if (newTheme === "dark") {
                    root.classList.add("dark");
                } else {
                    root.classList.remove("dark");
                }
                localStorage.setItem("theme", newTheme);
            }
            return { theme: newTheme };
        });
    },
}));
